module.exports = __webpack_public_path__ + "img/15.4e5e0c9e.jpg";